import { useEffect, useState } from 'react';

type Props = { children: React.ReactNode };

export function RequireAuth({ children }: Props) {
  const [status, setStatus] = useState<'checking' | 'authed'>('checking');

  useEffect(() => {
    let cancelled = false;

    async function check() {
      try {
        const res = await fetch('/auth/me', {
          method: 'GET',
          credentials: 'include',
          headers: { Accept: 'application/json' },
        });

        if (cancelled) return;

        if (res.ok) {
          setStatus('authed');
          return;
        }

        redirectToLogin();
      } catch (e) {
        if (cancelled) return;
        console.error(e);
        redirectToLogin();
      }
    }

    function redirectToLogin() {
      window.location.assign(`/oauth2/authorization/cognito`);
    }

    check();

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'checking') return <div>Checking session…</div>;

  return <>{children}</>;
}
